import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGiftCard } from "@fortawesome/pro-light-svg-icons/faGiftCard";
import styles from "../../styles/presentational/header.css";

export class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <header className={styles.header}>
        <div className={styles.logo}>
          <a
            className={styles.link}
            href={this.props.links.header_logo}
            target="_blank"
          >
            <img
              className={styles.image}
              src={this.props.images.header_logo.src}
              alt={this.props.images.header_logo.alt}
            />
          </a>
        </div>
        {this.props.donation ? (
          <div className={styles.donation}>
            <FontAwesomeIcon className={styles.icon} icon={faGiftCard} />
            <div className={styles.label}>
              {this.props.dictionary.header_donation}
            </div>
            <div className={styles.amount}>
              {this.props.donation.amount.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
              })}
            </div>
          </div>
        ) : null}
      </header>
    );
  }
}
